// src/components/site-editor/panels/ScrollAnimationPanel.js
import React from 'react';
import { useWebsiteBuilder } from '../../../contexts/WebsiteBuilderContext';

const ANIMATION_OPTIONS = [
  { id: 'none', label: 'None', description: 'Sections load instantly with no animation.' },
  { id: 'fadeIn', label: 'Fade In', description: 'Sections gently appear as visitors scroll down.' },
  { id: 'slideUp', label: 'Slide Up', description: 'Sections glide upward into view as visitors scroll.' },
  { id: 'scale', label: 'Scale', description: 'Sections zoom into view as visitors scroll down.' },
];

const ScrollAnimationPanel = () => {
  const { state, actions } = useWebsiteBuilder();
  const current = state.draft.design.scrollAnimation || 'fadeIn';

  return (
    <div className="p-6 space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-1">Scroll Animation</h3>
        <p className="text-sm text-slate-600">Choose how sections appear as visitors scroll your site</p>
      </div>

      <div className="space-y-3">
        {ANIMATION_OPTIONS.map((option) => (
          <button
            key={option.id}
            onClick={() => actions.updateDesign('scrollAnimation', option.id)}
            style={{
              width: '100%',
              padding: '16px',
              border: current === option.id ? '2px solid #7c3aed' : '2px solid #E5E7EB',
              borderRadius: '8px',
              background: current === option.id ? '#F3F0FF' : 'white',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s'
            }}
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="text-sm font-semibold text-gray-900 mb-1">{option.label}</div>
                <div className="text-xs text-gray-600">{option.description}</div>
              </div>
              {current === option.id && (
                <div style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: '#7c3aed',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'white' }} />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {current !== 'none' && (
        <p style={{ fontSize: '11px', color: '#999', marginTop: '6px', fontStyle: 'italic' }}>
          Animations play once as each section comes into view. Publish your site and scroll through it to see the full effect.
        </p>
      )}
    </div>
  );
};

export default ScrollAnimationPanel;
